import Vue from 'vue';
import {
  ValidationProvider, ValidationObserver, extend,
} from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';

extend('one_uppercase', {
  validate: (value: string) => {
    const regex = /(?=.*[A-Z])/;
    return regex.test(value);
  },
});

extend('must_true', {
  validate: (flag: boolean) => flag,
});

extend('one_lowercase', {
  validate: (value: string) => {
    const regex = /(?=.*[a-z])/;
    return regex.test(value);
  },
});

extend('one_number', {
  validate: (value: string) => {
    const regex = /(?=.*[0-9])/;
    return regex.test(value);
  },
});

extend('one_special', {
  validate: (value: string) => {
    const regex = /(?=.*?[#?!@$%^&*-.:])/;
    return regex.test(value);
  },
});

extend('match', {
  validate: (value: string, params: any) => value === params.join(','),
});

extend('domain', {
  validate: (value: string) => {
    const regex = /^(?!-)[A-Za-z0-9-]+([-.]{1}[a-z0-9]+)*\.[A-Za-z]{2,6}$/;
    return regex.test(value);
  },
});

extend('noHtml', {
  validate: (value: string) => {
    const regex = /^((?!<[^>]+>).)*$/;
    return regex.test(value);
  },
});

Object.entries(rules).forEach(([rule, validation]) => {
  extend(rule, {
    ...validation,
  });
});

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
